<template>
  <v-card :disabled="loading" :loading="loading">
    <v-card-title>
      <h2>{{ $t("officer_config.config_year") }}</h2>
    </v-card-title>
    <v-card-text>
      <v-tabs v-model="level_tab">
        <v-tabs-slider color="yellow"></v-tabs-slider>
        <v-tab v-for="(level, i) in levels" :key="i">
          <h3>{{ objectTranslator(level, "LEVEL_NAME") }}</h3>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="level_tab" touchless>
        <v-tab-item v-for="(level, i) in levels" :key="i">
          <v-card flat>
            <v-card-text>
              <v-btn
                small
                color="success"
                @click="$refs.addEditDialog.open_add_modal(level.LEVEL_ID)"
                class="mt-3"
              >
                <v-icon>mdi-plus</v-icon>{{ $t("officer_config.addnew") }}
              </v-btn>
              <v-simple-table min-height="300px" class="mt-3">
                <thead class="blue-grey darken-1">
                  <tr>
                    <th class="white--text text-center" width="100px">
                      {{ $t("officer_config.edit") }}
                    </th>
                    <th class="white--text text-center" width="100px">
                      {{ $t("officer_config.delete") }}
                    </th>
                    <th class="white--text">#</th>
                    <th class="white--text">
                      {{ $t("officer_config.academic_year") }}
                    </th>
                    <th class="white--text">
                      {{ $t("officer_config.semester") }}
                    </th>
                    <th class="white--text">
                      {{ $t("officer_config.admit_date") }}
                    </th>
                    <th class="white--text">
                      {{ $t("officer_config.start_using_date") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="year_item in listFilter(
                      config_years,
                      level.LEVEL_ID,
                      'LEVEL_ID'
                    )"
                    v-bind:key="year_item.YEAR_ID"
                  >
                    <td>
                      <v-btn
                        small
                        color="warning"
                        v-on:click="
                          $refs.addEditDialog.open_edit_modal(year_item)
                        "
                      >
                        <v-icon>mdi-pencil</v-icon
                        >{{ $t("officer_config.edit") }}
                      </v-btn>
                    </td>
                    <td>
                      <v-btn
                        small
                        color="error"
                        @click="open_delete_modal(year_item)"
                      >
                        <v-icon>mdi-delete</v-icon
                        >{{ $t("officer_config.delete") }}
                      </v-btn>
                    </td>
                    <td>{{ year_item.YEAR_ID }}</td>
                    <td>{{ year_item.YEAR }}</td>
                    <td>{{ year_item.SEMESTER }}</td>
                    <td>{{ dt(year_item.ADMIT_DATE) }}</td>
                    <td>{{ dt(year_item.START_DATE) }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>

    <ConfigYearAddEditDialog
      ref="addEditDialog"
      :toggle_loading="toggle_loading"
    />

    <ConfigDeleteDialog
      v-model="showing_delete_modal"
      :title="$t('officer_config.config_year')"
      :text="
        to_delete_year_item
          ? ' ' +
            to_delete_year_item.YEAR +
            ' / ' +
            to_delete_year_item.SEMESTER +
            ' / (' +
            objectTranslator(
              getById(levels, to_delete_year_item.LEVEL_ID, 'LEVEL_ID'),
              'LEVEL_NAME'
            ) +
            ')'
          : ''
      "
      :deleteFunction="delete_config_year"
    />
  </v-card>
</template>

<script>
import { createHelpers } from "vuex-map-fields";
import ConfigYearAddEditDialog from "@/components/config/ConfigYearAddEditDialog";
import ConfigDeleteDialog from "@/components/config/ConfigDeleteDialog";
import {
  objectTranslator,
  dateFromDBTranslator as dt,
} from "@/helper/translator";
import { getYearsModified } from "@/helper/dateTime";
import { getById } from "@/helper/filter";
import { listFilter } from "@/helper/filter";
import ConfigProvider from "@/services/config.provider";

const configService = new ConfigProvider();
const { mapFields: mapOfficerConfigFields } = createHelpers({
  getterType: "officerConfig/getField",
  mutationType: "officerConfig/updateField",
});

export default {
  name: "configYear",
  data: function() {
    return {
      loading: false,
      level_tab: null,

      showing_delete_modal: false,

      to_delete_year_id: null,
      to_delete_year_item: null,
    };
  },
  components: {
    ConfigYearAddEditDialog,
    ConfigDeleteDialog,
  },
  computed: {
    levels() {
      return this.$store.state.ref.levels;
    },
    ...mapOfficerConfigFields({
      config_years: "config_years",
    }),
  },
  methods: {
    dt,
    objectTranslator,
    getYearsModified,
    listFilter,
    getById,
    toggle_loading(status) {
      this.loading = status;
    },
    open_delete_modal: function(item) {
      this.to_delete_year_id = item.YEAR_ID;
      this.to_delete_year_item = item;
      this.showing_delete_modal = true;
    },
    delete_config_year: async function() {
      this.loading = true;
      let response = await configService
        .deleteYears({
          year_id: this.to_delete_year_id,
        })
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
        });
      this.showing_delete_modal = false;
      this.$store.dispatch("officerConfig/getYears");
      if (response && response.status)
        this.$toasted.success(this.$t("toasted.delete_successfully"));
      else this.$toasted.error(this.$t("toasted.cannot_delete"));
      this.loading = false;
    },
  },
  mounted: function() {
    this.$store.dispatch("ref/getLevels");
    this.$store.dispatch("officerConfig/getYears");
  },
};
</script>
